import { faCircleXmark, faCross, faEdit, faEllipsisVertical, faPlus, faRefresh, faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CardBasic from 'components/Cards/Card.basic'
import DCMDropdown from 'components/DropDown/DropDown.index'
import ClientModal from 'components/Modals/Client.modal'
import PromptModal from 'components/Modals/Prompt.modal'
import Toolbar from 'components/Toolbar/Toolbar'
import { removeEmptyValues } from 'helpers/request.helper'
import React, { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { AdminService } from 'Services/adminService'

export default function ExamClients() {
    const { examId } = useParams();
    const [clients, setClients] = useState<any[]>([]);
    const [showModal, setShowModal] = useState(false);

    async function getClients() {
        await AdminService.getClients(examId)
            .then((res) => {
                if (res.status === 200) {
                    // console.log(res.data);
                    setClients(res?.data || []);
                }
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message || "Failed to fetch clients");
                console.error(err);
            });
    }

    async function createClient(data: any) {
        let payload = {
            ...data,
            allottedExam: examId
        };
        payload = removeEmptyValues(payload);
        await AdminService.createClient(payload)
            .then((res) => {
                if (res.status === 200) {
                    toast.success("Client created successfully");
                    setShowModal(false);
                    getClients();
                }
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message || "Failed to create client");
                console.error(err);
            });
    }

    useEffect(() => {
        getClients();
    }, [examId]);

    return (
        <>
            <CardBasic
                cardClass="mt-3"
                title={
                    <div className='d-flex justify-content-between align-items-center mb-3'>
                        <div className="">
                            <h5>
                                Exam Clients
                            </h5>
                        </div>
                        <div className="d-flex justify-content-end">
                            <Toolbar
                                values={[
                                    {
                                        value: <>
                                            <FontAwesomeIcon icon={faPlus} size="sm" className="me-2" />
                                            Create Client
                                        </>,
                                        onClick: () => setShowModal(true),
                                        variant: "secondary"
                                    }
                                ]}
                                size="sm"
                            />
                        </div>
                        <ClientModal
                            show={showModal}
                            onHide={() => setShowModal(false)}
                            onSubmit={createClient}
                            mode="create"
                        />

                    </div>
                }
                body={
                    <>
                        <ClientTable tableData={clients} reload={getClients} />
                    </>
                }
            />
        </>
    )
};

function ClientTable({ tableData, reload }: { tableData: any[], reload: () => void }) {
    const [showModal, setShowModal] = useState<string>("");
    const [newPassword, setNewPassword] = useState("");
    const [data, setData] = useState<any>(null);

    async function handleToggleBlock(clientId: string) {
        await AdminService.toggleBlockClient(clientId)
            .then((res) => {
                if (res.status === 200) {
                    toast.success("Client status updated successfully");
                    reload();
                }
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message || "Failed to update client status");
                console.error(err);
            });
    }

    async function resetPassword(clientId: string) {
        await AdminService.resetClientPassword(clientId)
            .then((res) => {
                if (res.status === 200) {
                    setNewPassword(res.data?.password);
                }
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message || "Failed to reset password");
                console.error(err);
            });
    }

    async function handleUpdate(data_: any) {
        if (!data_?.name || !data_?.email || !data_?.mobile) {
            toast.error("Please fill all the fields");
            return;
        }
        let payload: any = {
            name: data_?.name,
            email: data_?.email,
            mobile: data_?.mobile,
            allottedExam: data?.allottedExam || "",
        };
        payload = removeEmptyValues(payload);

        await AdminService.updateClient(showModal, payload)
            .then((res) => {
                if (res.status === 200) {
                    toast.success("Client updated successfully");
                    setShowModal("");
                    reload();
                }
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message || "Failed to update client");
                console.error(err);
            });

    }
    return (
        <>
            <Table striped borderless className="xrg-table" size="lg" responsive>
                <thead>
                    <tr>
                        <th>Sr. No.</th>
                        <th className='text-nowrap'>Name</th>
                        <th className='text-center'>Email</th>
                        <th className='text-center'>Phone</th>
                        <th className='text-center'>Status</th>
                        <th className='text-center'>Suspended</th>
                        <th></th>
                        <th className='text-nowrap'></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        tableData?.length > 0 ? tableData.map((client, index) => (
                            <tr key={client._id}>
                                <td>{index + 1}</td>
                                <td className='text-nowrap'>{client?.name || "N/A"}</td>
                                <td className='text-center'>{client?.email || "N/A"}</td>
                                <td className='text-center'>{client?.mobile || "N/A"}</td>
                                <td className='text-center'>{client?.status}</td>
                                <td className='text-center'>{client?.isSuspended ? "Yes" : "No"}</td>
                                <td>
                                    <DCMDropdown
                                        menuItems={[
                                            {
                                                label: (
                                                    <div className="text-secondary">
                                                        <FontAwesomeIcon icon={faCircleXmark} className="me-2" />
                                                        {
                                                            client?.isSuspended ? "Unsuspend Client" : "Suspend Client"
                                                        }
                                                    </div>
                                                ),
                                                onClick: () => handleToggleBlock(client?._id),
                                            },
                                            {
                                                label: (
                                                    <div className="text-secondary">
                                                        <FontAwesomeIcon icon={faRefresh} className="me-2" />
                                                        Reset Password
                                                    </div>
                                                ),
                                                onClick: () => resetPassword(client?._id),
                                            },
                                            {
                                                label: (
                                                    <div className="text-danger">
                                                        <FontAwesomeIcon icon={faEdit} className="me-2" />
                                                        Update Client
                                                    </div>
                                                ),
                                                onClick: () => {
                                                    setShowModal(client?._id);
                                                    setData(client);
                                                }
                                            }

                                        ]}
                                        menuLabel={
                                            <FontAwesomeIcon
                                                icon={faEllipsisVertical}
                                                className="cursor-pointer"
                                            />
                                        }
                                        title={
                                            <div className="text-primary fw-bold">
                                                Actions
                                            </div>
                                        }
                                    />
                                </td>
                            </tr>
                        )) : <tr><td colSpan={7} className="text-center">No clients found</td></tr>
                    }
                </tbody>
            </Table>

            <PromptModal
                show={newPassword !== ""}
                setShow={() => setNewPassword("")}
                body={
                    <>
                        <div>
                            <span>
                                Password Changed to <b>{newPassword}</b>
                            </span>
                        </div>
                    </>
                }
            />

            <ClientModal
                show={showModal !== ""}
                onHide={() => setShowModal("")}
                onSubmit={handleUpdate}
                mode="update"
                initialData={data ? {
                    name: data?.name,
                    email: data?.email,
                    mobile: data?.phone
                } : {}}
            />

        </>
    )
}

